import { jsx } from "react/jsx-runtime";
import { Text } from "@wix/wix-ui-tpa/cssVars";
const JapanPostalCodeMarkWUT = () => {
  return /* @__PURE__ */ jsx(Text, { children: "〒" });
};
export {
  JapanPostalCodeMarkWUT as default
};
//# sourceMappingURL=japan-postal-code-mark-wut.js.map
